import React from 'react';
import LegalPage from './LegalPage';

const SECTIONS = [
    {
        heading: '1. Acceptance of Terms',
        body: 'By accessing or using Kobra Prep (the "Service"), you agree to be bound by these Terms & Conditions. If you do not agree, please do not use the Service. These terms apply to all visitors and registered users.',
    },
    {
        heading: '2. Accounts',
        body: 'Some features require an account. You are responsible for the accuracy of the information you provide and for keeping your login credentials secure. You are responsible for all activity that occurs under your account. Notify us immediately of any unauthorized use.',
    },
    {
        heading: '3. Acceptable Use',
        body: 'You agree to use Kobra Prep for personal, non-commercial exam preparation only. You may not scrape, bulk-download, resell, or redistribute questions, answers, or explanations; attempt to gain unauthorized access to our systems; or use the Service in any way that disrupts other users or violates applicable law.',
    },
    {
        heading: '4. Free and Premium Features',
        body: 'Kobra Prep offers free tests and practice as well as optional paid premium plans. Daily usage limits may apply to free features. Premium features, pricing, and durations are shown at the point of purchase and may change over time.',
    },
    {
        heading: '5. Payments and Refunds',
        body: 'Premium purchases are processed through our payment partners (e.g. bKash / SSLCommerz). Prices are shown in Bangladeshi Taka (৳). Except where required by law or expressly stated, payments are non-refundable once the subscription period has begun. Any approved refunds are handled at our discretion.',
    },
    {
        heading: '6. Intellectual Property',
        body: 'All content on Kobra Prep — including the question bank, answers, explanations, branding, and design — is owned by Kobra Prep or its licensors and is protected by law. You receive a limited, personal, non-transferable licence to use the content for your own study only.',
    },
    {
        heading: '7. User-Submitted Content',
        body: 'When you post comments, reports, or feedback, you grant us a non-exclusive right to use that content to operate and improve the Service. Do not submit unlawful, offensive, or infringing content.',
    },
    {
        heading: '8. Content Accuracy Disclaimer',
        body: 'We work hard to keep our questions and explanations accurate and up to date, but we do not guarantee that all content is error-free or reflects the latest official syllabus. Kobra Prep is a preparation aid and does not guarantee any exam result.',
    },
    {
        heading: '9. Limitation of Liability',
        body: 'To the maximum extent permitted by law, Kobra Prep is provided "as is" and we are not liable for any indirect, incidental, or consequential damages arising from your use of the Service.',
    },
    {
        heading: '10. Termination',
        body: 'We may suspend or terminate access to the Service if these terms are violated. You may stop using the Service at any time.',
    },
    {
        heading: '11. Changes to These Terms',
        body: 'We may update these Terms from time to time. Continued use of the Service after changes take effect constitutes acceptance of the revised Terms.',
    },
    {
        heading: '12. Governing Law',
        body: 'These Terms are governed by the laws of Bangladesh, without regard to conflict-of-law principles.',
    },
];

export default function TermsAndConditions() {
    return (
        <LegalPage
            title="Terms & Conditions"
            updated="July 2026"
            intro="Please read these Terms & Conditions carefully before using Kobra Prep. They govern your access to and use of our website and services."
            sections={SECTIONS}
        />
    );
}
